"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var GroupsController = /** @class */ (function () {
    function GroupsController(controllerConfig) {
        var _this = this;
        this.goToGroup = function (groupId) {
            _this.wixCodeApi.location.to("/group/" + groupId + "/discussion");
        };
        this.createGroup = function (details, settings, image) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupId, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setProps({
                            isGroupCreating: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.group.create(details, settings, image)];
                    case 2:
                        groupId = (_a.sent()).groupId;
                        this.goToGroup(groupId);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // TODO: handle error
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.setProps({
                            isGroupCreating: false,
                        });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var appParams = controllerConfig.appParams, setProps = controllerConfig.setProps, wixCodeApi = controllerConfig.wixCodeApi;
        this.wixCodeApi = wixCodeApi;
        this.setProps = setProps;
        this.initExternalServices(appParams.instance);
    }
    GroupsController.prototype.changeMembership = function (group) {
        // Need this because of refreshing `group` in `this.initExternalServices`
        return this.group.changeMembership(group);
    };
    GroupsController.prototype.refreshApiToken = function (instance) {
        this.initExternalServices(instance);
    };
    GroupsController.prototype.fetchGroups = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getGroupList()];
                    case 1: return [2 /*return*/, (_a.sent()).data.groups];
                }
            });
        });
    };
    GroupsController.prototype.initExternalServices = function (instance) {
        this.api = new social_groups_api_1.default(instance, baseUrl_1.default(this.wixCodeApi));
        this.group = new social_groups_api_1.Group('', this.api);
    };
    return GroupsController;
}());
exports.default = GroupsController;
//# sourceMappingURL=GroupsController.js.map